import { useModalContext } from 'utils/contexts/modal';
import { isAnchorTagNode } from '../utils/isAnchorTagNode';
import { isNode } from '../utils/isNode';
import { useEditorEventHandler } from './useEditorEventHandler';
import { HYPERLINK_MODAL_ID } from '../constants';
import { useEditorContext } from '../contexts/editor';
import { ClickListenerEvent } from '../types';

export const useLinkDoubleClickHandler = () => {
  const { editor } = useEditorContext();
  const { showModal } = useModalContext();
  useEditorEventHandler([ClickListenerEvent.DoubleClick], ({ target }) => {
    if (isNode(target) && isAnchorTagNode(target)) {
      editor?.selection.select(target);
      showModal(HYPERLINK_MODAL_ID);
    }
  });
};
